import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAuditLogList = async ({ companyCode, fromDate, toDate }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAuditLogList}?CompanyCode=${companyCode}&FromDate=${fromDate}&ToDate=${toDate}`
  );
  return data;
};

const getAuditLog = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetAuditLog}?CompanyCode=${companyCode}&AuditLogId=${code}`
  );
  return [data];
};

export const useGetAuditLogListQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAuditLogList],
    queryFn: () => getAuditLogList(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetAuditLogQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAuditLog],
    queryFn: () => getAuditLog(input),
    refetchOnWindowFocus: false,
  });
};
